<template>
  <div>
    <b-card-body>

      <b-table
          ref="feature-table"
          striped
          responsive
          v-bind:items="calls"
          v-bind:fields="fields"
          :busy="loading"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle mx-1"></b-spinner>
            <strong>{{ msg('Loading') }}...</strong>
          </div>
        </template>

        <template #cell(duration)="data">
          <span>{{ formatDuration(data.value) }}</span>
        </template>
        <template #cell(from)="data">
          <b-button size="sm" variant="danger" @click="onClientSelect(clients[data.value])"
                    v-if="clients[data.value]!=null">{{ clients[data.value].clientFullname }} ({{ data.value }})
          </b-button>
          <span v-else>Unknown ({{ data.value }})</span>
        </template>
        <template #cell(price)="data">
          <span v-if="data.value!=null">
            {{ convertToEURO(data.value*(-1)) }}
          </span>
        </template>
        <template #cell(startTime)="data">
          <div>
            {{ $moment(data.value).format('DD/MM/YY HH:mm') }}
          </div>
        </template>
        <template #cell(endTime)="data">
          <div>
            {{ $moment(data.value).format('DD/MM/YY HH:mm') }}
          </div>
        </template>
        <template #cell(status)="data">
          <b-badge :variant="getStatusVariant(data.value)">
            {{ msg(data.value) }}
          </b-badge>
        </template>
        <template #cell(direction)="data">
          <div class="d-flex align-items-center">
    <span
        v-if="data.value === 'outbound'"
        class="badge rounded-pill text-bg-success d-flex align-items-center"
    >
      <i class="fas fa-arrow-up me-1 mr-1"></i> {{ msg(data.value) }}
    </span>

            <span
                v-else-if="data.value === 'inbound'"

            >
      <i class="fas fa-arrow-down me-1 mr-1"></i> {{ msg(data.value) }}
    </span>

            <span
                v-else
                class="badge rounded-pill text-bg-secondary"
            >
      {{ msg('Unknown') }}
    </span>
          </div>
        </template>

      </b-table>
      <div class="text-center w-100 d-flex align-items-center justify-content-center">

        <!-- Previous Button -->
        <b-button
            variant="outline-primary"
            size="sm"
            class="mx-1"
            :disabled="page.previousPageUrl==null || loading"
            @click="goToPreviousPage"
        >
          ‹ {{ msg('Previous') }}
        </b-button>

        <!-- Next Button -->
        <b-button
            variant="outline-primary"
            size="sm"
            class="mx-1"
            :disabled="page.nextPageUrl==null || loading"
            @click="goToNextPage"
        >
          {{ msg('Next') }} ›
        </b-button>

      </div>


    </b-card-body>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CallsTable",
  components: {},
  props: ["filter"],
  watch: {
    filter: {
      deep: true,
      handler() {
        this.page.currentPage = 1; // Reset to first page on filter change
        this.refresh();
      },
      immediate: true
    },
  },
  data: () => ({
    loading: true,
    clients: {},
    loadingStats: true,
    interval: null,
    calls: [],
    dialogs: {
      client: false,
    },
    selected: null,

    page: {
      previousPageUrl: null,
      nextPageUrl: null,
    },
    stats: {},
  }),
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    fields() {
      let $this = this
      return [
        /*    {
              key: 'sid',
              label: $this.msg('sid'),
              sortable: true
            },*/
        {
          key: 'from',
          label: $this.msg('caller'),
          sortable: true
        },
        {
          key: 'to',
          label: $this.msg('receiver'),
          sortable: true
        },
        {
          key: 'status',
          label: $this.msg('status'),
          sortable: true
        },
        {
          key: 'startTime',
          label: $this.msg('start'),
          sortable: true
        },
        {
          key: 'endTime',
          label: $this.msg('end'),
          sortable: true
        },
        {
          key: 'duration',
          label: $this.msg('duration'),
          sortable: true
        },
        {
          key: 'direction',
          label: $this.msg('direction'),
          sortable: true
        },
        {
          key: 'price',
          label: $this.msg('price'),
          sortable: true
        }
      ]
    }
    ,
  },
  created() {
    // this.interval = setInterval(this.fetchData, 10_000); // Refresh every 10 seconds
  },
  beforeDestroy() {
    // clearInterval(this.interval);
  },
  methods: {
    ...mapActions('reception', ['fetchAllCalls']),

    goToNextPage() {
      this.filter.pageUrl = this.page.nextPageUrl;
      this.refresh();
    },
    goToPreviousPage() {
      this.filter.pageUrl = this.page.previousPageUrl;
      this.refresh();
    },

    getStatusVariant(status) {
      switch (status) {
        case 'queued':
          return 'secondary'
        case 'ringing':
          return 'info'
        case 'in-progress':
          return 'primary'
        case 'completed':
          return 'success'
        case 'busy':
          return 'warning'
        case 'failed':
          return 'danger'
        case 'no-answer':
          return 'dark'
        case 'canceled':
          return 'light'
        default:
          return 'secondary'
      }
    },
    formatDuration(seconds) {
      const total = parseInt(seconds, 10);
      if (isNaN(total) || total < 0) return '-';

      const minutes = Math.floor(total / 60);
      const secs = total % 60;

      if (minutes > 0) {
        return `${minutes} min ${secs} sec`;
      } else {
        return `${secs} sec`;
      }
    },
    refresh() {
      let $this = this;
      this.loading = true;
      this.fetchData().finally(() => {
        $this.loading = false;
      });
    },

    onClientSelect(client) {
      this.selected = client.id
      this.dialogs.client = true
      this.$root.$emit('bv::hide::popover')
      this.$root.$emit('crm::client::select', client.id)

    },
    convertToEURO(someNumber) {
      return new Intl.NumberFormat("de-AT", {
        style: "currency",
        currency: "EUR",
      }).format(someNumber);
    },
    fetchData() {
      let $this = this;

      return this.fetchAllCalls({
        filter: this.filter
      }).then(data => {
        $this.calls = data.calls || [];

        // Store the cursor URLs for Next/Previous
        $this.page.nextPageUrl = data.nextPageUrl || null;
        $this.page.previousPageUrl = data.previousPageUrl || null;

        // Convert clients to map by phone number
        $this.clients = (data.clients || []).toObject("phone");
      });
    }

  }
}
</script>


<style scoped>

</style>
